module.exports = __webpack_public_path__ + "img/paper02.f18ec637.svg";